import API from '../interceptors/Api';

const BASE_URL = '/coe-applications';

export const getCoeApplications = (params) => API.get(BASE_URL, {
  params,
});

export const getCoeApplicationsAggregations = (params) => API.get(`${BASE_URL}/aggregations`, {
  params,
});

export const getCoeApplicationsExpired = (params) => API.get(`${BASE_URL}/expirations`, {
  params,
});

export const getCoeApplicationsToExpire = (params) => API.get(`${BASE_URL}/to-expire`, { params });
